import { TFunction } from 'i18next';
import { z } from 'zod';

import { MAX_UPLOAD_SIZE_MB } from '@feature/utils/upload/fileUpload';

import { travelReferenceDocumentKindList } from './TravelReferenceDocumentTypes';

export const travelReferenceDocumentSearchSchema = z.object({
  kind: z.enum(travelReferenceDocumentKindList).optional().catch(undefined),
});

export type TravelReferenceDocumentSearch = z.infer<typeof travelReferenceDocumentSearchSchema>;

const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;

const isPdf = (file: File) => file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');

// The picker's accept filter can be bypassed with "All files", so the type is checked again here.
export const getTravelReferenceDocumentUploadSchema = (t: TFunction) =>
  z.object({
    file: z
      .custom<File>(value => value instanceof File, { params: { i18n: 'custom.fileRequired' } })
      .refine(isPdf, t('travel.referenceDocuments.notPdf'))
      .refine(
        file => file.size <= MAX_UPLOAD_SIZE_BYTES,
        t('notification.error.fileTooLarge', { maxSize: MAX_UPLOAD_SIZE_MB }),
      ),
  });

export type TravelReferenceDocumentUploadSchema = z.infer<ReturnType<typeof getTravelReferenceDocumentUploadSchema>>;
